// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  max-width:400px;
  margin-bottom: 60px;
  margin: auto;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 1.2rem;
}

.input-label {
  margin-bottom: 0.3rem;
  font-weight: 500;
  color: var(--text-color);
}

.input-error {
  font-size: 0.85rem;
  color: #ff4c4c;
  margin-top: 0.3rem;
}

.input-control {
  width: 100%;
  padding: 0.6rem 0.75rem;
  border: 1px solid var(--border-color);
  background-color: var(--bs-secondary-bg);
  color: var(--text-color);
  font-size: 1rem;
  border-radius: 4px;
  transition: border-color 0.2s ease;
}

.input-control:focus {
  border-color: var(--bs-border-color);
  outline: none;
  box-shadow: 0 0 0 2px var(--bs-btn-hover-border-color);
}

.input-control.error {
  border-color: #ff4c4c;
}

.turnstile-wrapper {
  transform: scale(0.9); /* Adjust scale as needed */
  transform-origin: top left;
}`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,qCAAqC;EACrC,wCAAwC;EACxC,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,sDAAsD;AACxD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB,EAAE,2BAA2B;EAClD,0BAA0B;AAC5B","sourcesContent":[".login-container {\n  max-width:400px;\n  margin-bottom: 60px;\n  margin: auto;\n}\n\n.input-wrapper {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 1.2rem;\n}\n\n.input-label {\n  margin-bottom: 0.3rem;\n  font-weight: 500;\n  color: var(--text-color);\n}\n\n.input-error {\n  font-size: 0.85rem;\n  color: #ff4c4c;\n  margin-top: 0.3rem;\n}\n\n.input-control {\n  width: 100%;\n  padding: 0.6rem 0.75rem;\n  border: 1px solid var(--border-color);\n  background-color: var(--bs-secondary-bg);\n  color: var(--text-color);\n  font-size: 1rem;\n  border-radius: 4px;\n  transition: border-color 0.2s ease;\n}\n\n.input-control:focus {\n  border-color: var(--bs-border-color);\n  outline: none;\n  box-shadow: 0 0 0 2px var(--bs-btn-hover-border-color);\n}\n\n.input-control.error {\n  border-color: #ff4c4c;\n}\n\n.turnstile-wrapper {\n  transform: scale(0.9); /* Adjust scale as needed */\n  transform-origin: top left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
